import { Schemas } from '~/api/gen'
import { MetaData } from '~/components/Meta'
import { getUserNameForSeo } from '~/lib/getUserNameForSeo'

const getTitle = (member: Schemas.member_large_detail): string => {
  return `${getUserNameForSeo({
    nickname: member.nick_name,
    wearista: member.is_wearista,
    shopClerk: member.is_shop_clerk,
    shopName: member.shop?.name,
  })}のコーディネート一覧`
}

const getDescription = (
  member: Schemas.member_large_detail,
  coordinateCollection: Schemas.get_members_user_name_coordinates_v1_response
): string => {
  const brand0 = member.often_use_coordinate_item_brands?.[0]
  const brand1 = member.often_use_coordinate_item_brands?.[1]
  if (brand0 && brand1) {
    return `${getTitle(member)}（${coordinateCollection.total_count}）です。${
      brand0.name
    }や${brand1.name}を使った私服や着こなしを見ることができます。`
  }
  if (brand0) {
    return `${getTitle(member)}（${coordinateCollection.total_count}）です。${
      brand0.name
    }を使った私服や着こなしを見ることができます。`
  }
  return `${getTitle(
    member
  )}です。WEARはモデル・俳優・ショップスタッフなどの着こなしをチェックできるファッションコーディネートサイトです。`
}

export const getMetadata = (
  member: Schemas.member_large_detail,
  coordinateCollection: Schemas.get_members_user_name_coordinates_v1_response
): MetaData => {
  return {
    title: getTitle(member),
    description: getDescription(member, coordinateCollection),
    ogImageUrl: member.image.url_640 ?? undefined,
    url: `https://wear.jp/${member.user_name}/`,
    appUrl: `wear2020://wear.jp/user/${member.id}/`,
    robots: coordinateCollection.total_count !== 0,
  }
}
